const ACTIVE = Symbol('Active');
const INACTIVE = Symbol('Inactive');
export const RuleStatus = { ACTIVE, INACTIVE } as const;
export type RuleStatus = (typeof RuleStatus)[keyof typeof RuleStatus];
